// DialogOpenEvent/DialogCloseEvent (assets/dialog.js) don't bubble, so the
// listener must be attached to each dialog-component instance directly —
// a single document-level listener would never fire.
const dialogs = document.querySelectorAll('.lookbook-modal');

dialogs.forEach((dialog) => {
  const component = dialog.closest('dialog-component');
  const video = dialog.querySelector('video');

  if (!component || !video) return;

  component.addEventListener('dialog:open', () => video.play());
  component.addEventListener('dialog:close', () => video.pause());
});
